import React from 'react';
import { ModalWindow, SwitchDialogWindows } from '../../ui-toolkit/components';
import { IFetchStatus } from 'types/rest/IFetchStatus';

export const SaveConversationStatusModal: React.FC<{
  fetchStatus: IFetchStatus;
  fetchError?: Error;
  close: () => void;
}> = ({ fetchStatus, fetchError, close }) => (
  <SwitchDialogWindows
    errorTitle={'There was an error saving this conversation'}
    isCompleted={fetchStatus.fetched}
    isError={!!fetchError}
    isLoading={fetchStatus.fetching}
    onCloseClick={close}
    successTitle={'Conversation was updated.'}
  >
    <ModalWindow width={700} title="Save Conversation" contentTextAlign="left" onClose={close} />
  </SwitchDialogWindows>
);
